var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(pdfjsLib.version, "/pdf.worker.min.js");
export function PdfPreview(_a) {
    var _this = this;
    var fileUrl = _a.fileUrl;
    var canvasRef = useRef(null);
    useEffect(function () {
        if (!fileUrl)
            return;
        var canvas = canvasRef.current;
        if (!canvas)
            return;
        var renderPDF = function () { return __awaiter(_this, void 0, void 0, function () {
            var loadingTask, pdf, page, context, viewport, renderContext, renderTask;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loadingTask = pdfjsLib.getDocument(fileUrl);
                        return [4 /*yield*/, loadingTask.promise];
                    case 1:
                        pdf = _a.sent();
                        return [4 /*yield*/, pdf.getPage(1)];
                    case 2:
                        page = _a.sent();
                        context = canvas.getContext("2d");
                        if (!context)
                            return [2 /*return*/];
                        viewport = page.getViewport({ scale: 0.5 });
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;
                        renderContext = {
                            canvasContext: context,
                            viewport: viewport,
                        };
                        renderTask = page.render(renderContext);
                        return [2 /*return*/, renderTask.promise];
                }
            });
        }); };
        var renderTask;
        renderPDF().then(function (task) { renderTask = task; })
            .catch(function (e) {
            if ((e === null || e === void 0 ? void 0 : e.name) !== "RenderingCancelledException") {
                console.error("Erro ao renderizar PDF:", e);
            }
        });
        return function () {
            if (renderTask === null || renderTask === void 0 ? void 0 : renderTask.cancel) {
                renderTask.cancel();
            }
        };
    }, [fileUrl]);
    return _jsx("canvas", { ref: canvasRef, style: { borderRadius: 4, width: "100%", height: "100%", objectFit: "cover" } });
}
